import React from 'react';
import VideoPlayerWeb from './VideoPlayerWeb';
import VideoPlayerMobile from './VideoPlayerMobile';

const VideoPlayer = ({ openLoginPopup }) => {
  const isMobile = window.innerWidth <= 768;
  return isMobile ? (
    <VideoPlayerMobile openLoginPopup={openLoginPopup} />
  ) : (
    <VideoPlayerWeb openLoginPopup={openLoginPopup} />
  );
};

export default VideoPlayer;
